import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { APIService, GetTokensQuery, Tokens } from '../API.service';
import { v4 as uuidv4 } from 'uuid';
import {Router} from '@angular/router';
import { D2TApi } from 'src/app/doc2txt/utils/d2tApi';
import { HttpClient } from '@angular/common/http';
import { Auth } from 'aws-amplify';


const moment = require('moment');

@Component({
  selector: 'app-tokens',
  templateUrl: './tokens.component.html',
  styleUrls: ['./tokens.component.css'],
})
export class TokensComponent implements OnInit {
  columnsToDisplay = [
    'userExists',
    'name',
    'countCurrentMonth',
    'countPrevMonth',
    'total',
    'enable',
    'date',
  ];
  public createForm: FormGroup;
  token: GetTokensQuery;

  /* declare tokens variable */
  public tokens: Array<{
    token: Tokens;
    totalCount: number;
    countCurrentMonth: number;
    countPrevMonth: number;
  }> = [];
  newUUID: null | string;
  user: any;

  constructor(private api: APIService, private fb: FormBuilder, private router: Router,private http: HttpClient) {
    this.newUUID = null;
    this.createForm = this.fb.group({
      name: ['', Validators.required],
      type: ['topUp', Validators.required],
      month: [],
    });
  }

  async ngOnInit(): Promise<void> {
    this.user = await Auth.currentUserInfo();

    this.token = await this.api.GetTokens(this.user.username);    

    const getAdminTokenData = async (token: Tokens) => {
      const d2tApi = new D2TApi(this.http, this.token);

      const request$ = d2tApi.getAdminTokenData(token.owner);
      const that = this;

      return new Promise<{
        token: Tokens;
        totalCount: number;
        countCurrentMonth: number;
        countPrevMonth: number;
      }>((resolve, reject) => {
        request$.subscribe(async (adminTokenData: any) => {
          resolve({
            token: token,
            totalCount: adminTokenData.countTotal ?? 0,
            countCurrentMonth: adminTokenData.countCurrentMonth ?? 0,
            countPrevMonth: adminTokenData.countPreviousMonth ?? 0,
          });
        }, (error: any) => {
          reject(error);
        });
      });
    }

    /* fetch tokens when app loads */
    this.api.ListTokens().then(async (event) => {
      event.items = event.items.filter((token:any) => token.uuid !== "-");
      this.tokens = await Promise.all(
        (event.items as Tokens[]).map(getAdminTokenData)
      );
      this.tokens = this.tokens.filter((token:any) => token.totalCount !== 0 
      // &&  (token.countCurrentMonth !== 0 || token.countPrevMonth !== 0)
      );

    });
  }

  public onCreate(token: Tokens) {
    const res = confirm("Are you sure you want to create a new token?");
    if (!res) {
      return;
    }
    token.date = new Date().toISOString().substring(0, 10);
    token.enable = true;
    token.uuid = uuidv4();
    token.description = token.name;
    token.userExists = false;
    token.owner = token.uuid;

    this.api
      .CreateTokens(token)
      .then((res) => {
        this.newUUID = token.uuid;
        console.log('item created!', this.newUUID);
        this.createForm.reset();
      })
      .catch((e) => {
        console.log('error creating token...', e);
      });
  }

  public gotoTokenDetails(token: Tokens) {
    this.router.navigateByUrl('/tokenDetails?token=' + token.id);
  }
}
